import { useMemo } from 'react';
import { CustomNmcObj } from '../../../../../../types/entities';
import { formatCurrency } from '../../../../../../utils/formatCurrency';

export const useGetPrice = ({
    amount,
    currencyCaracterCode,
    isPercent,
    percentValue,
    customNmcTitle,
}: {
    amount: number;
    currencyCaracterCode: string;
    isPercent: boolean;
    percentValue: number;
    customNmcTitle: CustomNmcObj;
}) =>
    useMemo(
        () =>
            `${formatCurrency(amount, currencyCaracterCode)} ${
                isPercent
                    ? `(${percentValue} % от ${customNmcTitle.genitiveCaseAbbrTitle})`
                    : ''
            }`,
        [
            amount,
            currencyCaracterCode,
            customNmcTitle.genitiveCaseAbbrTitle,
            isPercent,
            percentValue,
        ]
    );
